import { useCallback } from "react";

import type { PlatformRequestError } from "../types/platformRequestError.ts";
import { useTT } from "../useTT.ts";

export function useTranslateAuthError() {
  const { tt } = useTT();

  return useCallback(
    (err: PlatformRequestError) => {
      const errorCode = err?.response?.data?.errorCode;

      switch (errorCode) {
        case "AuthMethodNotConfigured":
          return tt("dialog.Errors.authMethodNotConfigured");
        case "AuthCodeUnknown":
        case "AuthCodeNoMatch":
          return tt("dialog.Errors.authCodeInvalid");
        case "AuthCodeExpired":
          return tt("dialog.Errors.authCodeExpired");
        default:
          return tt("genericErrors.genericMessage");
      }
    },
    [tt],
  );
}
